import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { ProjectState } from 'reduxStore/project/initialState';
import {
  fetchProjectLayout,
  saveProjectLayout,
} from 'reduxStore/project/projectLayout/asyncActions';
import { addAsyncCasesNew } from 'shared/utils/redux';

export const projectLayoutReducer = (builder: ActionReducerMapBuilder<ProjectState.Domain>) => {
  addAsyncCasesNew(builder, fetchProjectLayout, (state, action) => {
    state.layoutResource = action.payload;
  });

  addAsyncCasesNew(builder, saveProjectLayout, (state, action) => {
    state.layoutResource = action.payload;
  });
};
